"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneNumberRange = void 0;
const MGRSConstants_1 = require("../MGRSConstants");
const GridZones_1 = require("./GridZones");
/**
 * Zone Number Range
 */
class ZoneNumberRange {
    /**
     * Constructor
     *
     * @param west
     *            western zone number
     * @param east
     *            eastern zone number
     */
    constructor(west = MGRSConstants_1.MGRSConstants.MIN_ZONE_NUMBER, east = MGRSConstants_1.MGRSConstants.MAX_ZONE_NUMBER) {
        this.west = west;
        this.east = east;
        this.zoneNumber = west;
    }
    /**
     * Get the western zone number
     *
     * @return western zone number
     */
    getWest() {
        return this.west;
    }
    /**
     * Set the western zone number
     *
     * @param west
     *            western zone number
     */
    setWest(west) {
        this.west = west;
    }
    /**
     * Get the eastern zone number
     *
     * @return eastern zone number
     */
    getEast() {
        return this.east;
    }
    /**
     * Set the eastern zone number
     *
     * @param east
     *            eastern zone number
     */
    setEast(east) {
        this.east = east;
    }
    /**
     * Get the western longitude
     *
     * @return longitude
     */
    getWestLongitude() {
        return GridZones_1.GridZones.getLongitudinalStrip(this.west).getWest();
    }
    /**
     * Get the eastern longitude
     *
     * @return longitude
     */
    getEastLongitude() {
        return GridZones_1.GridZones.getLongitudinalStrip(this.east).getEast();
    }
    next() {
        if (this.zoneNumber <= this.east) {
            const currentZoneNumber = this.zoneNumber;
            this.zoneNumber++;
            return {
                done: false,
                value: currentZoneNumber,
            };
        }
        else {
            return {
                done: true,
                value: null,
            };
        }
    }
    reset() {
        this.zoneNumber = this.west;
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.ZoneNumberRange = ZoneNumberRange;
//# sourceMappingURL=ZoneNumberRange.js.map